import { Logger, getLogger } from "analogging";
import { useConst } from "./useConst";

/** Gets a logger for use in a component */
export function useLogger(logName: string): Logger {
    return useConst(() => getLogger(logName));
}